import api, { BASE_URL } from "../../api";

import fileDownload from "js-file-download";

const PRODUCT_BASE_URL = `${BASE_URL}/shop/admin/products/`;

const IMAGE_UPLOAD_URL = pk => {
  return `${PRODUCT_BASE_URL}${pk}/upload-image/`;
};

const listProducts = context => {
  return api(context)
    .get(PRODUCT_BASE_URL)
    .then(response => response.data);
};

const getProduct = (context, key) => {
  return api(context)
    .get(`${PRODUCT_BASE_URL}${key}/`)
    .then(response => response.data);
};

const getProductContent = (context, key) => {
  return api(context)
    .get(`${PRODUCT_BASE_URL}${key}/content/`)
    .then(response => response.data);
};

const getProductLimitedReleaseList = (context, key) => {
  return api(context)
    .get(`${PRODUCT_BASE_URL}${key}/limited-release/`)
    .then(response => response.data);
};

const updateProductLimitedRelease = (context, limited_release) => {
  return api(context)
    .put(`${PRODUCT_BASE_URL}${limited_release.productID}/limited-release/`, limited_release)
    .then(response => response.data);
};

const removeProductLimitedRelease = (context, key) => {
  return api(context)
    .delete(`${PRODUCT_BASE_URL}${key}/limited-release/`)
    .then(response => response.data);
};

const updateProduct = (context, product) => {
  return api(context)
    .patch(`${PRODUCT_BASE_URL}${product.key}/`, product)
    .then(response => response.data);
};

const duplicateProduct = (context, product) => {
  return api(context)
    .post(`${PRODUCT_BASE_URL}${product.key}/duplicate/`)
    .then(response => response.data);
};

const updateProductContent = (context, product) => {
  return api(context)
    .post(`${PRODUCT_BASE_URL}${product.key}/content/`, product)
    .then(response => response.data);
};

const insertProduct = (context, product) => {
  return api(context)
    .post(PRODUCT_BASE_URL, product)
    .then(response => response.data);
};

const bulkExportProducts = (context, query) => {
  let url = !!query
    ? query.replace("/products/", "/products/export/")
    : `${PRODUCT_BASE_URL}export/`;
  return api(context)
    .get(url)
    .then(response => response.data)
    .then(data => {
      const today = new Date();
      const filename = `products_${today.getFullYear()}_${today.getMonth() +
        1}_${today.getDate()}.csv`;
      fileDownload(data, filename);
      return data;
    });
};

const bulkUpdateProducts = (context, formData) => {
  return api(context)
    .post(`${PRODUCT_BASE_URL}update-all/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(response => response.data);
};

export const product = {
  BASE_URL: PRODUCT_BASE_URL,
  IMAGE_UPLOAD_URL: IMAGE_UPLOAD_URL,
  list: listProducts,
  get: getProduct,
  update: updateProduct,
  insert: insertProduct,
  duplicate: duplicateProduct,
  content: {
    get: getProductContent,
    update: updateProductContent
  },
  limited_release: {
    get: getProductLimitedReleaseList,
    update: updateProductLimitedRelease
  },
  bulk: {
    export: bulkExportProducts,
    update: bulkUpdateProducts
  }
};

export default product;
